import { Component, OnInit, Input } from '@angular/core';
import { emptyFields, Country, UsersType, SettlementDocumentStatus,
textForSettlementDocumentStatus, settlementDocumentStatusOptions, gstColumnName } from '../utilities/common-file';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { countries } from '../utilities/countries';
import { UntypedFormGroup } from '@angular/forms';
import { CommonService } from 'src/app/utilities/common-service';

@Component({
  selector: 'app-view-settlement-details',
  templateUrl: './view-settlement-details.component.html',
})
export class ViewSettlementDetailsComponent implements OnInit {

    @Input() value: any;
    @Input() reportType: any;
    selectedTransaction: any;
    emptyField = emptyFields;
    country = Country;
    countries = countries;
    UsersType = UsersType;
    statusForm: UntypedFormGroup;
    settlementStatus = SettlementDocumentStatus;
    textForDocumentStatus = textForSettlementDocumentStatus;
    documentStatusOptions = [];
    loadingForPayment = false;
    selectedResponseData: any;
    selectedDataRequest: any;
    selectedResponse: any;
    private selectedTab = 0;
    selectedIndex = 0;
    gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
    gstColumnName = gstColumnName;
  columnName :any;
  constructor(private drawerRef: NzDrawerRef, private commonService: CommonService) {
     }

  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.selectedTab -= 1;
    this.selectedTransaction = this.value;
    this.documentStatusOptions = settlementDocumentStatusOptions.filter(item => item.value !== this.selectedTransaction.settlementStatus);
}
tab(index: number) {
  this.selectedTab = index;
}
viewResponse() {
  this.selectedDataRequest = '';
  this.selectedResponse = '';
}
 // Get Frequency Status
getFrequencyForSettlementStatus(status) {
  return this.commonService.getSettlementFrequencyStatus(status);
}
getUserType(role) {
  return this.commonService.getUserType(role);
}
getCurrency(currency) {
const index = this.countries.findIndex(M => M.currency_code ===  currency);
if (index !== -1) {
    return this.countries[index].currency_symbol;
}
}
close() {
  this.drawerRef.close();
}

}
